import { render, staticRenderFns } from "./PostingDetail.vue?vue&type=template&id=23724196&scoped=true&"
import script from "./PostingDetail.vue?vue&type=script&lang=js&"
export * from "./PostingDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostingDetail.vue?vue&type=style&index=0&id=23724196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23724196",
  null
  
)

export default component.exports